import { Alert, Button, Card, CardActions, CardContent, Divider, Grid, MenuItem, Snackbar, TextField, Typography } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '../../../AuthProvider'
import { collection, getDocs, onSnapshot, orderBy, query, where, addDoc } from 'firebase/firestore'
import { database } from '../../../firebaseConfig'
import { Link, useNavigate } from 'react-router-dom';
import LoadingButton from '@mui/lab/LoadingButton'
import AccessDinied from '../../../components/AccessDinied';
import dateFormat, { masks } from "dateformat";
function AddReservation() {
    const navigate = useNavigate()
    const { user } = useContext(AuthContext)
    const chu_user = user.chu_id
    const chu_code = user.chu_code
    const [chus, setChus] = useState([])
    const [services, setServices] = useState([])
    const [chu, setChu] = useState(chu_user)
    const [service, setService] = useState(null)
    const [dateRdv, setDateRdv] = useState(null)
    const [HeureRdv, setHeureRdv] = useState(null)
    const [nom, setNom] = useState('')
    const [prenom, setPrenom] = useState('')
    const [age, setAge] = useState(null)
    const [sexe, setSexe] = useState('M')
    const [contact, setContact] = useState('')
    const [email, setEmail] = useState('')
    const [errorData, setErrorData] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')
    const [successData, setSuccessData] = useState(false)
    const [successMessage, setSuccessMessage] = useState('')
    const [loading, setLoading] = useState(false)
    const listeChu_service = async () => {
        const res = []
        const q = query(collection(database, 'service_chu'), where('chu_id', "==", chu), where("status", "==", true))
        const chu_service_refs = await getDocs(q);
        const service_listes = await liste_service()
        chu_service_refs.forEach(chu_service => {
            var nom_service = ''
            const serviceFilter = service_listes.find(obj => obj.id == chu_service.data().service_id)
            if (serviceFilter && serviceFilter != undefined) {
                nom_service = serviceFilter.nom_service
            }
            res.push({
                ...chu_service.data(),
                nom_service: nom_service
            })
        })
        setServices([...res])
    }
    const liste_service = async () => {
        const res = []
        const q = query(collection(database, 'service'), orderBy('nom_service', 'asc'))
        const service_refs = await getDocs(q);
        service_refs.forEach(serviceData => {
            res.push({
                id: serviceData.id,
                ...serviceData.data()
            })
        })
        return res
    }
    useEffect(() => {
        const q = query(collection(database, 'chu'), orderBy('nom_chu', 'asc'))
        onSnapshot(q, (querySnapshot) => {
            setChus(querySnapshot.docs.map(doc => ({
                id: doc.id,
                ...doc.data()
            })))
        })
        listeChu_service()
    }, [chu])
    const handleCloseAlert = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setErrorData(false)
        setSuccessData(false)
    }
    const Envoyer = async (e) => {
        e.preventDefault()
        if (chu != null && service != null && dateRdv != null && HeureRdv != null && nom != '' && age != '' && sexe != '' && contact != '') {
            setLoading(true)
            e.preventDefault()
            const reservations = await listReservationParDate(service, chu, dateRdv)
            let num_reservation = 1
            if (reservations.length > 0) {
                const maxReference = reservations.reduce((max, item) => {
                    const currentXxxx = parseInt(item.reference.split('/').pop());
                    const maxXxxx = parseInt(max.reference.split('/').pop());
                    return currentXxxx > maxXxxx ? item : max;
                }, reservations[0]);
                num_reservation = parseInt(maxReference.reference.split('/').pop()) + 1;
            }
            const num_reference = num_reservation.toString().padStart(4, '0');
            try {
                const result = await addDoc(collection(database, 'reservation'), {
                    reference:  `${chu_code}/${dateFormat(new Date(dateRdv), "yyyymmdd")}/${num_reference}`,
                    service_id: service,
                    chu_id: chu,
                    date_rdv: dateRdv,
                    heure_rdv: HeureRdv,
                    nom: nom,
                    prenom: prenom,
                    age: age,
                    genre: sexe,
                    email: email,
                    contact: contact,
                    status: true,
                    lieu: 'Sur place'
                })
                if (result) {
                    setSuccessData(true)
                    setSuccessMessage('Insertion réussie')
                    setLoading(false)
                    setNom('')
                    setPrenom('')
                    setAge('')
                    setSexe('M')
                    setContact('')
                    setEmail('')
                    navigate('/admin/ticket/'+result.id)
                } else {
                    setErrorData(true)
                    setErrorMessage('Erreur lors d\'enregistrement!')
                }

            } catch (err) {
                setErrorData(true)
                setErrorMessage('Erreur lors d\'enregistrement!')
            }

        } else {
            setErrorData(true)
            setErrorMessage('Veuillez remplir les champs obligatoire!')
        }
    }
    const changeChu = (e) => {
        setChu(e.target.value)
        setService(null)
    }
    const changeservice = (e) => {
        setService(e.target.value)
    }
    const changeDateRDV = (e) => {
        setDateRdv(e.target.value)
        setHeureRdv(null)
    }
    const changeHeureRDV = (e) => {
        setHeureRdv(e.target.value)
    }
    const changeAge = (e) => {
        setAge('')
        if (e.target.value != '' && e.target.value>=0) {
            setAge(e.target.value)
        }
        
    }
    const listReservationParDate = async (idService, idChu, dateReservation) => {
        const res = []
        const q = query(collection(database, 'reservation'), where('service_id', '==', idService), where('chu_id', '==', idChu), where('date_rdv', '==', dateReservation))
        const reservation_refs = await getDocs(q);
        reservation_refs.forEach(reservation => {
            res.push({
                id: reservation.id,
                ...reservation.data()
            })
        })
        return res

    }
    if (user.type != 'Utilisateur') {
        return <AccessDinied />
    }
    return (
        <div style={{ width: '100%', flexGrow: 1, overflow: 'hidden', minHeight: 400 }}>
            <Typography variant='h5' sx={{ display: 'flex', justifyContent: 'center' }}>Ajout rendez-vous sur place</Typography>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: 5, padding: 2 }}>
                <Card sx={{ maxWidth: 700 }}>
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item xs={12} sm={12} md={12}>
                                <TextField
                                    required
                                    fullWidth
                                    label="CHU"
                                    select
                                    value={chu}
                                    onChange={changeChu}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    disabled={chu_user != null}
                                >
                                    {chus.map((chu_item) =>
                                    (
                                        <MenuItem key={chu_item.id} value={chu_item.id}>{chu_item.nom_chu}</MenuItem>
                                    )
                                    )}
                                </TextField>
                            </Grid>
                            <Grid item xs={12} sm={12} md={6}>
                                <TextField
                                    required
                                    select
                                    fullWidth
                                    label="Service"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={service}
                                    onChange={changeservice}
                                >
                                    {services.map((service_item) =>
                                    (
                                        <MenuItem key={service_item.service_id} value={service_item.service_id}>{service_item.nom_service}</MenuItem>
                                    )
                                    )}
                                </TextField>
                            </Grid>
                            <Grid item xs={6} sm={6} md={3}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Date"
                                    type='date'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={changeDateRDV}
                                    value={dateRdv}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={3}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Heure"
                                    type='time'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={changeHeureRDV}
                                    value={HeureRdv}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Nom"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => {
                                        setNom(e.target.value)
                                    }}
                                    value={nom}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    label="Prénom"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => {
                                        setPrenom(e.target.value)
                                    }}
                                    value={prenom}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Age"
                                    type='number'
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={changeAge}
                                    value={age}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    required
                                    select
                                    fullWidth
                                    label="Sexe"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    value={sexe}
                                    onChange={(e) => {
                                        setSexe(e.target.value)
                                    }}
                                >
                                    <MenuItem key={0} value="M">Masculin</MenuItem>
                                    <MenuItem key={1} value="F">Féminin</MenuItem>
                                </TextField>
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    required
                                    fullWidth
                                    label="Contact"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => {
                                        setContact(e.target.value)
                                    }}
                                    type='number'
                                    value={contact}
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={4}>
                                <TextField
                                    fullWidth
                                    label="Email"
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                    }}
                                    value={email}
                                />
                            </Grid>
                        </Grid>
                    </CardContent>
                    <Divider />
                    <CardActions style={{ display: 'flex', justifyContent: 'flex-end' }}>
                        <Button variant='contained' size="small" color='error' component={Link} to='/admin/reservation'>Annuler</Button>
                        <LoadingButton variant='contained'
                            size="small"
                            color='success'
                            onClick={Envoyer}
                            loading={loading}
                            loadingIndicator="Envoyer…"
                        >
                            Ajouter
                        </LoadingButton>
                    </CardActions>

                </Card>
                <Snackbar open={errorData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity="error"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {errorMessage}
                    </Alert>
                </Snackbar>
                <Snackbar open={successData} autoHideDuration={6000} onClose={handleCloseAlert} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
                    <Alert
                        onClose={handleCloseAlert}
                        severity="success"
                        variant="filled"
                        sx={{ width: '100%' }}
                    >
                        {successMessage}
                    </Alert>
                </Snackbar>
            </div>

        </div>
    )
}
export default AddReservation